import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaAtendimentoPj } from './types';

export const INITIAL_STATE: ConsultaAtendimentoPj = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaAtendimentoPj {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_ATENDIMENTO_PJ_REQUEST: {
				break;
			}
			case Types.CONSULTA_ATENDIMENTO_PJ_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_ATENDIMENTO_PJ_FAILURE: {
				draft.status = 0;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTA_ATENDIMENTO_PJ_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
